import type { VenueResponse } from "@/lib/types";

// Re-export from shared location for backward compatibility
export {
  formatFormIntResponseForDisplay,
  getPartyDisplay,
  getRequestType,
  getRequestTypeSingular,
  getRespondentDisplay,
  PropoundingPartyEnumHelper,
  replaceTokens,
  TryParseJsonToObject,
} from "@/lib/document-utils";

const venueSortRegex = new RegExp(/^(\d{1,3})\w{2}/);
export function SortVenue(a: VenueResponse, b: VenueResponse) {
  const aDigits = venueSortRegex.exec(a.shortName ?? "");
  const bDigits = venueSortRegex.exec(b.shortName ?? "");

  if (aDigits && bDigits) {
    const numberSort = Number(aDigits[1]) - Number(bDigits[1]);
    if (numberSort !== 0) {
      return numberSort;
    }
    const aWithoutDigits = a.shortName?.substring(aDigits.length + 2);
    const bWithoutDigits = b.shortName?.substring(bDigits.length + 2);
    return aWithoutDigits?.localeCompare(bWithoutDigits ?? "") ?? 0;
  }

  return a.shortName?.localeCompare(b.shortName ?? "") ?? 0;
}
